import { Dashboard } from "@/model/data/dashboard/Dashboard";
import { AxiosResponse } from "axios";
import { ApiGenericResponse } from "../../ApiGenericResponse";
import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../../Command";

const ENDPOINT = "/dashboard/";

export class CreateDashboardCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";

    dashboard: Dashboard;

    constructor(dashboard: Dashboard) {
        super();
        this.dashboard = dashboard;
    }

    public async execute(): Promise<ApiGenericResponse> {
        var res = await this.executeCommand(this.dashboard);
        return new ApiGenericResponse(res);
    }
}
